import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import SelectInput from './SelectInput';
import TextInput from './TextInput';
// import '../styles/formStyles.css'; // Importa el archivo CSS
import {
    getPaises,
    getCadenas,
    getRegiones,
    getProvincias,
    getComunas,
    getTiendas,
    getServicios,
    getHorarios,
    getHoras,
    getDocumentTypes
} from './getData'; // Importa las funciones del archivo getData.jsx

function ReservationForm() {
    const { register, watch } = useForm();
    const [paises, setPaises] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [tiendas, setTiendas] = useState([]);
    const [servicios, setServicios] = useState([]);
    const [horarios, setHorarios] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [horas, setHoras] = useState([]);

    const selectedPais = watch('pais');
    const selectedCadena = watch('cadena');
    const selectedRegion = watch('region');
    const selectedProvincia = watch('provincia');
    const selectedComuna = watch('comuna');
    const selectedTienda = watch('tienda');
    const selectedServicio = watch('servicio');
    const selectedDate = watch('fecha');
    const selectedHorarios = watch('horario');
    const selectedHora = watch('hora');
    const selectedDocumento = watch('documentType');
    const apellidoPaterno = watch('apellidoPaterno');
    const apellidoMaterno = watch('apellidoMaterno');
    const primerNombre = watch('primerNombre');
    const segundoNombre = watch('segundoNombre');
    const telefono = watch('telefono');
    const correo = watch('correo');
    const domicilio = watch('domicilio');
    const numeroDocumento = watch('numeroDocumento');
    const usoDatos = watch('usoDatos');

    // Usar un hook personalizado para hacer fetch de los datos
    useEffect(() => {
        getPaises().then(setPaises);
    }, []);

    useEffect(() => {
        if (selectedPais) {
            getCadenas(selectedPais).then(setCadenas);
        }
    }, [selectedPais]);

    useEffect(() => {
        if (selectedPais && selectedCadena) {
            getRegiones(selectedPais, selectedCadena).then(setRegiones);
        }
    }, [selectedPais, selectedCadena]);

    useEffect(() => {
        if (selectedRegion && selectedCadena) {
            getProvincias(selectedRegion, selectedCadena).then(setProvincias);
        }
    }, [selectedRegion, selectedCadena]);

    useEffect(() => {
        if (selectedProvincia && selectedCadena) {
            getComunas(selectedProvincia, selectedCadena).then(setComunas);
        }
    }, [selectedProvincia, selectedCadena]);

    useEffect(() => {
        if (selectedComuna && selectedCadena) {
            getTiendas(selectedComuna, selectedCadena).then(setTiendas);
        }
    }, [selectedComuna, selectedCadena]);

    useEffect(() => {
        if (selectedTienda) {
            getServicios(selectedTienda).then(setServicios);
        }
    }, [selectedTienda]);

    useEffect(() => {
        if (selectedDate && selectedTienda && selectedServicio) {
            getHorarios(selectedTienda, selectedServicio, selectedDate).then(setHorarios);
        }
    }, [selectedDate, selectedTienda, selectedServicio]);

    useEffect(() => {
        if (selectedDate && selectedTienda && selectedServicio && selectedHorarios) {
            getHoras(selectedTienda, selectedServicio, selectedHorarios, selectedDate).then(setHoras);
        }
    }, [selectedDate, selectedTienda, selectedServicio, selectedHorarios]);

    useEffect(() => {
        if (selectedPais) {
            getDocumentTypes(selectedPais).then(setDocumentTypes);
        }
    }, [selectedPais]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = {
            cfg_codigo: selectedTienda,
            tpc_codigo: selectedServicio,
            hor_fecha: selectedDate,
            htr_hora: selectedHora,
            tpo_codigo: selectedDocumento,
            int_apaterno: apellidoPaterno,
            int_amaterno: apellidoMaterno,
            int_pnombre: primerNombre,
            int_snombre: segundoNombre,
            int_telefono: telefono,
            int_email: correo,
            int_domicilio: domicilio,
            int_nrodocidentidad: numeroDocumento,
            int_usodedatospersonales: usoDatos
        };

        // console.log(formData);

        axios.post(`${process.env.REACT_APP_API_URL_AGENDAR_CITA}`, formData, {
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`
            }
        })
        .then(response => {
            alert(response.data.message); // Muestra el mensaje de éxito
        })
        .catch(error => {
            console.error('Hubo un problema al registrar la reserva.', error);
            alert('Hubo un problema al registrar la reserva.'); // Muestra un mensaje de error
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <SelectInput
                id="pais"
                label="País"
                options={paises}
                valueKey="codigoPais"
                labelKey="denominacionPais"
                {...register('pais')}
            />

            <SelectInput
                id="cadena"
                label="Cadenas"
                options={cadenas}
                valueKey="cda_codigo"
                labelKey="cda_descripcion"
                disabled={!selectedPais}
                {...register('cadena')}
            />

            <SelectInput
                id="region"
                label="Regiones"
                options={regiones}
                valueKey="dpt_codigo"
                labelKey="dpt_descripcion"
                disabled={!selectedCadena}
                {...register('region')}
            />

            <SelectInput
                id="provincia"
                label="Provincias"
                options={provincias}
                valueKey="prv_codigo"
                labelKey="prv_descripcion"
                disabled={!selectedRegion}
                {...register('provincia')}
            />

            <SelectInput
                id="comuna"
                label="Comunas"
                options={comunas}
                valueKey="ubg_codigo"
                labelKey="ubg_denominacion"
                disabled={!selectedProvincia}
                {...register('comuna')}
            />

            <SelectInput
                id="tienda"
                label="Tiendas"
                options={tiendas}
                valueKey="cfg_codigo"
                labelKey="descripcion"
                disabled={!selectedComuna}
                {...register('tienda')}
            />

            <SelectInput
                id="servicio"
                label="Servicios"
                options={servicios}
                valueKey="tpc_codigo"
                labelKey="tpc_denominacion"
                disabled={!selectedTienda}
                {...register('servicio')}
            />

            <TextInput
                id="fecha"
                label="Fecha"
                type="date"
                disabled={!selectedTienda}
                {...register('fecha')}
            />

            <SelectInput
                id="horario"
                label="Horarios"
                options={horarios}
                valueKey="codigoTurno"
                labelKey="turnoDescripcion"
                disabled={horarios.length === 0}
                {...register('horario')}
            />

            <SelectInput
                id="hora"
                label="Hora"
                options={horas.map(h => ({ value: h.hora, label: h.hora }))}
                valueKey="value"
                labelKey="label"
                disabled={horas.length === 0}
                {...register('hora')}
            />

            <SelectInput
                id="documentType"
                label="Tipo de Documento"
                options={documentTypes}
                valueKey="tpo_codigo"
                labelKey="tpo_descripcion"
                disabled={!selectedPais}
                {...register('documentType')}
            />

            <TextInput id="apellidoPaterno" label="Apellido Paterno" {...register('apellidoPaterno')} />
            <TextInput id="apellidoMaterno" label="Apellido Materno" {...register('apellidoMaterno')} />
            <TextInput id="primerNombre" label="Primer Nombre" {...register('primerNombre')} />
            <TextInput id="segundoNombre" label="Segundo Nombre" {...register('segundoNombre')} />
            <TextInput id="telefono" label="Número de Teléfono" {...register('telefono')} />
            <TextInput id="correo" label="Correo Electrónico" type="email" {...register('correo')} />
            <TextInput id="domicilio" label="Domicilio" {...register('domicilio')} />
            <TextInput id="numeroDocumento" label="Número de Documento de Identidad" {...register('numeroDocumento')} />

            <div className="grid-item-full">
                <label>
                    <input type="checkbox" id="usoDatos" {...register('usoDatos')} />
                    Acepto el uso de mis datos personales (1 = aceptado, 0 = no aceptado)
                </label>
            </div>

            <button type="submit">Registrar Cita</button>
        </form>
    );
}

export default ReservationForm;
